var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderCenter"},[_c('Header'),_c('div',{staticClass:"orderCenter_content"},[_c('LeftSide'),_c('router-view',{staticClass:"router"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }